// Framework and third-party non-UI
import React from 'react';

// Redux, contexts, and local helpers/utils/modules

// Component specific modules (Component-styled, etc.)

// App components

// Third-party components (buttons, icons, etc.)
import { CalciteCard } from '@esri/calcite-components-react';

type CalciteCardWrapperProps = React.ComponentProps<typeof CalciteCard>;

const CalciteCardWrapper = ({
  selected,
  loading,
  ...rest
}: CalciteCardWrapperProps) => {
  return (
    <CalciteCard
      loading={loading || undefined}
      selected={selected || undefined}
      {...rest}
    />
  );
};

export default CalciteCardWrapper;
